import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { GTMService } from '@services';
import { SearchStore, SearchType, UsersStore } from '@store';

import { InstallationsMigrationService } from '../../../../+installations/installations/installation-migration/installations-migration-service';
import { SearchService } from '../../../search.service';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSearchComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  loginId = '';
  firstName = '';
  familyName = '';
  city = '';
  street = '';
  postalCode = '';
  companyNumber = '';
  limit = 100;
  offset = 0;

  constructor(
    private searchService: SearchService,
    private searchStore: SearchStore,
    private cdr: ChangeDetectorRef,
    public gtmService: GTMService,
    public installationsMigrationService: InstallationsMigrationService,
    private usersStore: UsersStore
  ) {}

  ngOnInit(): void {
    this.searchService.userSearchParams$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((data) => !isEmpty(data))
      )
      .subscribe((data) => {
        this.loginId = data.searchParams.loginId;
        this.firstName = data.searchParams.firstName;
        this.familyName = data.searchParams.familyName;
        this.street = data.searchParams.street;
        this.city = data.searchParams.city;
        this.postalCode = data.searchParams.postalCode;
        this.companyNumber = data.searchParams.companyNumber;

        this.cdr.detectChanges();

        window.scrollTo(0, 80);

        this.search();
      });
  }

  search(): void {
    if (this.isSearchByUserCriteriaDisabled() || this.isSearchByCompanyIdDisabled()) {
      this.searchService.search$.next(SearchType.user);

      if (this.companyNumber) {
        this.searchStore.searchCompanyUsers(this.companyNumber);
        this.usersStore.listCompanyUsersSearchResult(this.companyNumber);
      } else {
        this.searchStore.searchUsers(
          this.loginId,
          this.firstName,
          this.familyName,
          this.city,
          this.street,
          this.postalCode
        );
        this.usersStore.listUsersSearchResult({
          loginId: this.loginId,
          firstName: this.firstName,
          familyName: this.familyName,
          city: this.city,
          street: this.street,
          postalCode: this.postalCode,
          limit: this.limit,
          offset: this.offset,
        });
      }
    }
  }

  isSearchByCompanyIdDisabled(): boolean {
    return !(
      (this.loginId && this.loginId.trim()) ||
      (this.firstName && this.firstName.trim()) ||
      (this.familyName && this.familyName.trim()) ||
      (this.city && this.city.trim()) ||
      (this.street && this.street.trim()) ||
      (this.postalCode && this.postalCode.trim())
    );
  }

  isSearchByUserCriteriaDisabled(): boolean {
    return !(this.companyNumber && this.companyNumber.trim());
  }

  clear(): void {
    this.loginId = '';
    this.firstName = '';
    this.familyName = '';
    this.city = '';
    this.street = '';
    this.postalCode = '';
    this.companyNumber = '';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.searchService.userSearchParams$.next(undefined);
  }
}
